import React, {Component} from 'react';
import {Snackbar} from '@material-ui/core';
import {addErrorListener, removeErrorListener} from 'util/errors';
import {CloseIcon} from 'components/Icon';
import './index.scss';

interface ErrorPopUpState {
  open: boolean;
  message: string;
}

export default class ErrorPopUp extends Component<{}, ErrorPopUpState> {
  state = {
    open: false,
    message: ''
  };

  componentDidMount(): void {
    addErrorListener(this.onError);
  }

  componentWillUnmount(): void {
    removeErrorListener(this.onError);
  }

  onError = (message: string, err: any) => {
    this.setState({open: true, message: message});
  };

  onClose = () => {
    this.setState({open: false});
  };

  onCloseClick = () => {
    this.setState({open: false});
  };

  render() {
    return <Snackbar className="error-popup" open={this.state.open} onClose={this.onClose} autoHideDuration={3000}
                     message={this.state.message} action={
      <button className="close" onClick={this.onCloseClick}><CloseIcon/></button>
    } />;
  }
}